module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('contacts.contact_details'),
      "iconFA": "address-book"
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.type_label'),
      "inputValue": _vm.typeContact
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.nme'),
      "inputValue": _vm.username
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.als'),
      "inputValue": _vm.label
    }
  })], 1), _vm._v(" "), (this.$settings.currentContact.typeContact === '1') ? _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.eml'),
      "inputValue": _vm.identifier
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (this.$settings.currentContact.typeContact === '2') ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.srn'),
      "inputValue": _vm.identifier
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', _vm._l((_vm.extractedBankData), function(bankData) {
    return _c('b-col', {
      key: bankData.labelId,
      staticClass: "form-group",
      attrs: {
        "sm": "6"
      }
    }, [_c('form-read-group-label-input', {
      attrs: {
        "idLabel": _vm.$t(bankData.labelId),
        "inputValue": bankData.value
      }
    })], 1)
  }), 1), _vm._v(" "), (this.$engine.user.currentService.id === '2') ? _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('bank_accounts.mandat_id'),
      "inputValue": ''
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('bank_accounts.mandat_date'),
      "inputValue": ''
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.phn_nbr'),
      "inputValue": _vm.phoneNumber
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.adrs'),
      "inputValue": _vm.address
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.cty'),
      "inputValue": _vm.city
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.zp_code'),
      "inputValue": _vm.zipCode
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "6"
    }
  }, [_c('form-read-group-label-input', {
    attrs: {
      "idLabel": _vm.$t('common.cntry'),
      "inputValue": _vm.country
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3",
      "offset-md": "5"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "href": "/account/editContact/",
      "disabled": !_vm.canEditContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "edit"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n            " + _vm._s(_vm.$t('contacts.edit_contact')) + "\n          ")])], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "md": "3"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    attrs: {
      "title": _vm.$t('common.rm_label'),
      "disabled": !_vm.canRemoveContact
    },
    on: {
      "click": _vm.removeContact
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "close_round_fill"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('contacts.supp_contact')))])], 1)], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72937088", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72937088","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contacts/CMContactDetail.vue
// module id = 2399
// module chunks = 2